export const ModalIds = {
  SHARE_VIEW_LINK: "share-view-link-modal",
} as const;

export type ModalId = (typeof ModalIds)[keyof typeof ModalIds];
